/** Canonical client pricing tiers (settlement × multiplier). */
export const DISPLAY_TIER_ORDER = ['mark-up-1-2', 'basic', 'premium', 'vip'];

/** Legacy DB tier names that map to a canonical tier. */
export const LEGACY_TIER_MAP = {
  'mark up 1.2': 'mark-up-1-2',
  markup12: 'mark-up-1-2',
  'markup-1-2': 'mark-up-1-2',
  markup: 'mark-up-1-2',
  bronze: 'basic',
  silver: 'premium',
  gold: 'vip',
  standard: 'basic',
  enterprise: 'vip',
};

export const FIXED_TIER_CONFIG = {
  'mark-up-1-2': {
    displayName: 'mark up 1.2',
    multiplier: 1.2,
    description: '20% markup',
    color: '#fa541c',
  },
  basic: {
    displayName: 'Basic',
    multiplier: 1.0,
    description: 'Basic pricing tier for new clients',
    color: '#1890ff',
  },
  premium: {
    displayName: 'Premium',
    multiplier: 0.95,
    description: 'Premium pricing tier with 5% discount',
    color: '#722ed1',
  },
  vip: {
    displayName: 'VIP',
    multiplier: 0.9,
    description: 'VIP pricing tier with 10% discount',
    color: '#52c41a',
  },
};

/**
 * Merge duplicate/legacy pricing tier rows into one canonical tier each.
 * Pricing Tier Management uses this; voucher previews must use the same logic.
 */
export function mergePricingTiersForDisplay(rawTiers) {
  const tiers = Array.isArray(rawTiers) ? rawTiers : [];
  const mergedCoreTiers = new Map();

  tiers.forEach((tier) => {
    const originalName = (tier.name || '').toLowerCase();
    const normalizedName = LEGACY_TIER_MAP[originalName] || originalName;
    if (!DISPLAY_TIER_ORDER.includes(normalizedName)) return;

    const existing = mergedCoreTiers.get(normalizedName);
    const preset = FIXED_TIER_CONFIG[normalizedName];
    const normalizedTier = {
      ...tier,
      sourceName: originalName,
      name: normalizedName,
      displayName: preset?.displayName || tier.displayName || normalizedName,
      multiplier: preset?.multiplier ?? tier.multiplier,
      description: preset?.description || tier.description,
      color: tier.color || preset?.color || '#1890ff',
    };

    if (
      !existing ||
      (existing.sourceName !== normalizedName && originalName === normalizedName)
    ) {
      mergedCoreTiers.set(normalizedName, normalizedTier);
    }
  });

  return DISPLAY_TIER_ORDER.map((tierName) => mergedCoreTiers.get(tierName)).filter(Boolean);
}
